import Box, {BoxProps} from '@mui/material/Box';
import {m} from 'framer-motion';
import {varAlpha} from 'minimal-shared/utils';

import {CONFIG} from '@minimal/global-config';

const APP_ENV = import.meta.env.VITE_APP_ENV.toUpperCase();

export const NavAppEnv = ({sx, ...other}: BoxProps) => {
  if (APP_ENV === 'PROD') {
    return null;
  }

  return (
    <Box
      sx={[
        (theme) => ({
          ...theme.mixins.bgGradient({
            images: [
              `linear-gradient(135deg, ${varAlpha(theme.vars.palette.error.lightChannel, 0.92)}, ${varAlpha(theme.vars.palette.secondary.darkChannel, 0.92)})`,
              `url(${CONFIG.assetsDir}/assets/background/background-7.webp)`,
            ],
          }),
          px: 2,
          py: 1,
          borderRadius: 2,
          position: 'relative',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Box
        sx={(theme) => ({
          top: 0,
          left: 0,
          width: 1,
          height: 1,
          borderRadius: 2,
          position: 'absolute',
          border: `solid 3px ${varAlpha(theme.vars.palette.common.whiteChannel, 0.16)}`,
        })}
      />

      <Box
        component={m.img}
        animate={{y: [12, -12, 12]}}
        transition={{
          duration: 8,
          ease: 'linear',
          repeat: Infinity,
          repeatDelay: 0,
        }}
        alt="Small Rocket"
        src={`${CONFIG.assetsDir}/assets/illustrations/illustration-rocket-small.webp`}
        sx={{
          right: 5,
          width: 45,
          height: 45,
          position: 'absolute',
        }}
      />

      <Box
        sx={{
          display: 'flex',
          position: 'relative',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <Box
          component="span"
          sx={{
            color: 'common.white',
            typography: 'subtitle2',
          }}
        >
          Attention vous êtes sur l'environnement de {APP_ENV}
        </Box>
      </Box>
    </Box>
  );
};
